"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonalInfoFieldTitleBefore = PersonalInfoFieldTitleBefore;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const react_intl_1 = require("react-intl");
const elements_1 = require("@src/components/elements");
const account_1 = require("@src/types/account");
function PersonalInfoFieldTitleBefore() {
    const intl = (0, react_intl_1.useIntl)();
    return ((0, jsx_runtime_1.jsx)(antd_1.Form.Item, { name: account_1.EPersonalInfoField.titleBefore, label: intl.formatMessage({ id: 'admin.personal_info_edit.title_before' }), rules: [
            {
                max: 12,
                message: intl.formatMessage({
                    id: 'admin.personal_info_edit_validation.title_before_can_have_max',
                }),
            },
        ], children: (0, jsx_runtime_1.jsx)(elements_1.Input, { maxLength: 12 }) }));
}
